import { TENANTS_NAMES } from './host_config';
import { getTenantPreLoginConfig } from './teanantPreLoginConfig';
import { fetchEnvironmentVariables } from './config';

const IS_TENANT =
  window.location.host !== process.env.REACT_APP_LOCAL_HOST &&
  window.location.host !== process.env.REACT_APP_STAGING_HOST &&
  window.location.host !== process.env.REACT_APP_PRODUCTION_HOST &&
  process.env.REACT_APP_LOCAL_HOST !== undefined;

const isTenantByName = (name) => {
  try {
    return (
      getTenantPreLoginConfig().tenant_name.toUpperCase() === name.toUpperCase()
    );
  } catch {
    return false;
  }
};

const SERVICES = {
  SEGMENT: !IS_TENANT && !isTenantByName('xpo'),
  INSPECTLET: !IS_TENANT && !isTenantByName('xpo'),
  BEAMER: !IS_TENANT && !isTenantByName('xpo'),
  SUPERSET: !IS_TENANT && !isTenantByName('xpo'),
};

const tenantsThirdPartyConfig = {
  [TENANTS_NAMES.intraser]: fetchEnvironmentVariables(TENANTS_NAMES.intraser),
  [TENANTS_NAMES.xpo]: fetchEnvironmentVariables(TENANTS_NAMES.xpo),
  [TENANTS_NAMES.ontruck]: fetchEnvironmentVariables(TENANTS_NAMES.ontruck),
  [TENANTS_NAMES.acme]: fetchEnvironmentVariables(TENANTS_NAMES.acme),
};

const TenantsStyles = {
  [`${TENANTS_NAMES.intraser}`]: `
    :root {
    --primary500: #0071CE;
    }`,
  [`${TENANTS_NAMES.xpo}`]: `
    :root {
    --primary500: #000;
    --primary-btn500: #CC0000;
    --primary-btn-main-menu:  #CC0000;
    --primary300: #E84949;
    --primary-300-opacity10:  #E84949E5;
    --accent-color-blue: #2396DC;
    }
    @media (max-width: 500px){
        .public-page{
            background: var(--primary500) !important;
        }

        .public-page .tenant-logo{
            width: 250px  !important;
            height: auto  !important;
            margin-top: 32px  !important;
            margin-left: auto  !important;
            margin-right: auto !important;
        }   
    }
    `,
};
const tenantStyles = TenantsStyles[getTenantPreLoginConfig().styles];

export {
  IS_TENANT,
  SERVICES,
  tenantStyles,
  isTenantByName,
  tenantsThirdPartyConfig,
};
